import type { FeatureMap } from './specimenFeatures';
import { taxonomyDatabase } from './taxonomyDatabase';

export function createUnknownSpecimen(random: () => number = Math.random): string {
  const ids = Object.keys(taxonomyDatabase).filter((id) => !taxonomyDatabase[id].referenceOnly);
  const value = random();
  if (!Number.isFinite(value) || value < 0 || value > 1) throw new RangeError('Random source must return a value from 0 to 1.');
  return ids[Math.min(ids.length - 1, Math.floor(value * ids.length))];
}

export function mergeObservedFeature(observations: FeatureMap, featureId: string, value: string | number | boolean): FeatureMap {
  return { ...observations, [featureId]: value };
}
